// src/components/portal/portal_components/navigation_bar.js
import React from 'react';
import {
  Box,
  Button,
  Container
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import PaletteIcon from '@mui/icons-material/Palette';
import UpdateIcon from '@mui/icons-material/Update';

const NavigationBar = ({ activeSection, onSectionChange }) => {
  const navItems = [
    {
      id: 'design',
      label: 'Design Settings',
      icon: <PaletteIcon />
    },
    {
      id: 'data',
      label: 'Data Settings',
      icon: <SettingsIcon />
    },
    // {
    //   id: 'updates',
    //   label: 'Next Update',
    //   icon: <UpdateIcon />
    // }
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        py: 1,
      }}
    >
      <Container 
        maxWidth="xl"
        sx={{
          backgroundColor: '#009688',
          borderTop: '1px solid #00796b',
          borderBottom: '1px solid #00796b',
          py: 1,
          borderRadius: 2
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0,
          }}
        >
          {navItems.map((item, index) => (
            <Button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              startIcon={item.icon}
              sx={{
                color: activeSection === item.id ? '#009688' : 'white',
                backgroundColor: activeSection === item.id ? 'white' : 'transparent',
                fontWeight: activeSection === item.id ? 'bold' : 'medium',
                px: 3,
                py: 1.5,
                mx: 0.5,
                borderRadius: 0,
                border: 'none',
                textTransform: 'none',
                fontSize: '1rem',
                minWidth: '160px',
                '&:hover': {
                  backgroundColor: activeSection === item.id ? '#f5f5f5' : 'rgba(255, 255, 255, 0.1)',
                },
                '&:first-of-type': {
                  borderTopLeftRadius: '8px',
                  borderBottomLeftRadius: '8px',
                },
                '&:last-of-type': {
                  borderTopRightRadius: '8px',
                  borderBottomRightRadius: '8px',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default NavigationBar;